(function () {
  'use strict';

  var MAP_SELECTOR = '[data-afe-media-variant-map]';
  var SLIDESHOW_SELECTOR = '[data-product-slideshow]';

  /* スライドの移動速度と止まり方 */
  var SELECTED_ATTRACTION = 0.04;
  var FRICTION = 0.32;

  /* 停止時の連続処理を1回にまとめる */
  var SETTLE_DELAY = 35;

  function getMediaId(element) {
    var media;

    if (!element) return '';

    if (element.hasAttribute('data-media-id')) {
      return String(element.getAttribute('data-media-id') || '');
    }

    media = element.querySelector('[data-media-id]');

    return media
      ? String(media.getAttribute('data-media-id') || '')
      : '';
  }

  function initMediaVariantSync(mapElement) {
    var section = mapElement.closest('.shopify-section');
    var slideshow;
    var mediaVariantMap;
    var mediaToOption = {};
    var radioByValue = {};
    var radioInputs;
    var attempts = 0;
    var maximumAttempts = 120;
    var settleTimer = null;
    var i;

    if (
      !section ||
      section.dataset.afeMediaSyncReady === 'true'
    ) {
      return;
    }

    try {
      mediaVariantMap = JSON.parse(mapElement.textContent);
    } catch (error) {
      console.warn(
        'AFE media/variant map could not be read.',
        error
      );
      return;
    }

    if (!Array.isArray(mediaVariantMap)) return;

    /*
     * 画像IDと色番号の対応を最初に保存します。
     * スワイプするたびに108色を検索しないための軽量化です。
     */
    for (i = 0; i < mediaVariantMap.length; i++) {
      if (
        mediaVariantMap[i] &&
        mediaVariantMap[i].mediaId != null &&
        mediaVariantMap[i].optionValue != null
      ) {
        mediaToOption[
          String(mediaVariantMap[i].mediaId)
        ] = String(mediaVariantMap[i].optionValue);
      }
    }

    radioInputs = section.querySelectorAll(
      'input[type="radio"][value]'
    );

    for (i = 0; i < radioInputs.length; i++) {
      radioByValue[
        String(radioInputs[i].value)
      ] = radioInputs[i];
    }

    slideshow = section.querySelector(
      SLIDESHOW_SELECTOR
    );

    if (!slideshow) return;

    section.dataset.afeMediaSyncReady = 'true';

    function connectToFlickity() {
      var Flickity =
        window.themeVendor &&
        window.themeVendor.Flickity
          ? window.themeVendor.Flickity
          : window.Flickity;

      var flickity;

      /*
       * Pipeline側のスライダー準備が完了するまで待ちます。
       */
      if (
        !Flickity ||
        typeof Flickity.data !== 'function'
      ) {
        attempts++;

        if (attempts < maximumAttempts) {
          window.setTimeout(
            connectToFlickity,
            50
          );
        } else {
          delete section.dataset.afeMediaSyncReady;
        }

        return;
      }

      flickity = Flickity.data(slideshow);

      if (!flickity) {
        attempts++;

        if (attempts < maximumAttempts) {
          window.setTimeout(
            connectToFlickity,
            50
          );
        } else {
          delete section.dataset.afeMediaSyncReady;
        }

        return;
      }

      /*
       * Pipeline標準より少し素早く移動し、
       * 短い時間で安定して止まる設定です。
       */
      flickity.options.selectedAttraction =
        SELECTED_ATTRACTION;

      flickity.options.friction = FRICTION;

      function syncVariantFromSelectedSlide() {
        var selectedElement =
          flickity.selectedElement;

        var mediaId =
          getMediaId(selectedElement);

        var optionValue =
          mediaToOption[mediaId];

        var radioInput;

        /*
         * 共通の紹介画像では、
         * 現在選択中の色を変更しません。
         */
        if (!optionValue) return;

        radioInput =
          radioByValue[optionValue];

        /*
         * 色が実際に変わる場合のみクリック処理を実行。
         * 同じ色に対する重複処理を防ぎます。
         */
        if (
          radioInput &&
          !radioInput.checked
        ) {
          radioInput.click();
        }
      }

      /*
       * 広範囲のMutationObserverは使用せず、
       * スライドが停止したときだけ同期します。
       */
      flickity.on('settle', function () {
        window.clearTimeout(settleTimer);

        settleTimer = window.setTimeout(
          syncVariantFromSelectedSlide,
          SETTLE_DELAY
        );
      });

      syncVariantFromSelectedSlide();
    }

    connectToFlickity();
  }

  function initAllMediaVariantSync(root) {
    var mapElements;
    var i;

    if (
      !root ||
      typeof root.querySelectorAll !== 'function'
    ) {
      return;
    }

    mapElements =
      root.querySelectorAll(MAP_SELECTOR);

    for (i = 0; i < mapElements.length; i++) {
      initMediaVariantSync(
        mapElements[i]
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAllMediaVariantSync(document);
      }
    );
  } else {
    initAllMediaVariantSync(document);
  }

  /*
   * Shopifyテーマ編集画面で
   * セクションが再読み込みされた場合にも対応します。
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAllMediaVariantSync(event.target);
    }
  );
})();